import {
  editService,
  removeService,
  updateServices,
  editServiceAtomic,
  updateServiceTeams,
} from './actions';

export default {
  [editService]: (state, { payload: { data } }) => {
    const { id, ...rest } = data;

    return {
      ...state,
      services: {
        ...state.services,
        [id]: {
          ...state.services[id],
          ...rest,
        },
      },
    };
  },
  [removeService]: (state, { payload: { data: { id, deletedAt, deletedBy } } }) => ({
    ...state,
    services: {
      ...state.services,
      [id]: {
        ...state.services[id],
        deletedAt,
        deletedBy,
        archived: true,
      },
    },
  }),
  [updateServices]: (state, { payload: { data } }) => ({
    ...state,
    services: {
      ...state.services,
      ...data,
    },
  }),
  [updateServiceTeams]: (state, { payload: { data } }) => ({
    ...state,
    services: {
      ...state.services,
      [data.id]: {
        ...state.services[data.id],
        ...data,
      },
    },
  }),
  [editServiceAtomic]: (state, { payload: { id, field, value, updatedAt, updatedBy } }) => ({
    ...state,
    services: {
      ...state.services,
      [id]: {
        ...state.services[id],
        [field]: value,
        updatedAt,
        updatedBy,
      },
    },
  }),
};
